var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOpd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5605 9.95713C20.5609 13.7829 23.3222 13.7829 23.3222 9.95713C23.3222 7.68603 21.9414 5.84424 21.9414 5.84424C21.9414 5.84424 20.5605 7.68603 20.5605 9.95713M18.5183 16.8739C18.5183 19.7868 21.2801 19.7872 21.2801 16.8739C21.2801 15.145 19.8992 13.7423 19.8992 13.7423C19.8992 13.7423 18.5183 15.145 18.5183 16.8739M8.25427 13.4747L11.7949 17.0563L17.359 11.4282L13.8183 7.84697L8.25427 13.4747Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8477 7.84063L16.0949 7.0793L15.3578 7.825L13.8184 6.26797L3.15156 17.0563L4.69063 18.6129L2.94062 20.3797L1.67734 19.102L1.17188 19.6141L5.72422 24.2188L6.23047 23.707L4.96484 22.427L6.71445 20.6594L8.25391 22.216L18.9203 11.4281L17.3812 9.87148L18.1184 9.12617L17.3652 8.36445L23.3344 2.32773L23.8281 0.78125L16.8477 7.84063ZM8.2543 21.1051L4.25039 17.0563L13.8184 7.3793L17.8219 11.4281L8.2543 21.1051V21.1051Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpd);
export default __webpack_public_path__ + "static/media/icon__opd.42ad1f8475a873d39b174ff629f46077.svg";
export { ForwardRef as ReactComponent };